var React = require('react');

function WhiteBook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.7 1.45605C3.03726 1.45605 2.5 1.97839 2.5 2.62272V14.2894C2.5 14.9337 3.03726 15.4561 3.7 15.4561H13.3C13.9627 15.4561 14.5 14.9337 14.5 14.2894V2.62272C14.5 1.97839 13.9627 1.45605 13.3 1.45605H8.5V6.41439C8.5 6.69468 8.13298 6.81362 7.96 6.58939L6.94 5.26717C6.82 5.11161 6.58 5.11161 6.46 5.26717L5.44 6.58939C5.26702 6.81362 4.9 6.69468 4.9 6.41439V1.45605H3.7ZM12.1 2.62272H12.7C13.0314 2.62272 13.3 2.88389 13.3 3.20605V13.7061C13.3 14.0282 13.0314 14.2894 12.7 14.2894H12.1V2.62272Z","fill":"white"}));
}

WhiteBook.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = WhiteBook;

WhiteBook.default = WhiteBook;
